import { all } from 'redux-saga/effects';

import cadastroConsulta from './cadastro/saga';
import consultaAtendimentosConsultaSaga from './consultaAtendimentosDeConsulta/saga';

export default all([cadastroConsulta, consultaAtendimentosConsultaSaga]);
